import { forwardRef } from "react";
import {
	PlateElement,
	type PlateElementProps,
} from "@platejs/core/react";

export const CodeLineElement = forwardRef<HTMLDivElement, PlateElementProps>(
	(props, ref) => <PlateElement ref={ref} {...props} />
);

CodeLineElement.displayName = "CodeLineElement";
